import React, { useState, useEffect } from 'react'
import { CImage,CCardHeader,
        CCardBody,CButton,
        CCardFooter, CCol, CRow, CCollapse,
        CInput, CForm,CCardText,CModal,
        CFormGroup, CLabel,
        CModalHeader, CModalBody,
        CDropdown,CCard,CCardTitle,CFooter } from 'compat/coreui';
import {IMAGE_URL} from '../../Constants/constants';
import { Route, Link } from 'react-router-dom';
import {getData, postData} from '../../helpers/api';
import {ToastContainer, toast} from 'react-toastify';

export default function Following() {
    const [follow, setFollow] = useState([]);

    useEffect(() => {
        getFollowers();
    }, [])

    const getFollowers = () =>{
        getData(`${process.env.REACT_APP_APP_API_URL}/api/follow`).then(res => {
            if(res.data.status){
                setFollow(res.data.following);
            }
        }).catch(console.log)
    }

    const unfollowHandler = (id) => {
        postData(`${process.env.REACT_APP_APP_API_URL}/api/unfollow`,{seller: id}).then(res => {
            if(res.data.status){
                getFollowers();
                toast.success("Unfollowed successfully");
            }
        }).catch(console.log)
    }
    return (
        <>
            <ul className="c_8 timeline">
                <li id="new_post">
                    <div className="seller-details m-5">
                        <CRow>
                        {follow.map((item, index) => {
                            return (<CCol sm="6" className="m-auto" key={index}>
                                        <CCard>
                                            <CCardHeader className="p-0 b-header">
                                                <CImage src="/images/placeholder.svg" width="100%"></CImage>
                                            </CCardHeader>
                                            <CCardBody className="text-center">
                                            <div className="b-pic">
                                                {item.image ? <img src={IMAGE_URL+item.image} /> : <img src="/images/placeholder.svg" />}
                                            </div>
                                            <div className="text-align header_title">
                                                <CCardTitle>
                                                    <span>{item.following.businessType}</span><br/>
                                                    <span><img src="/images/rating.jpg"/></span>
                                                </CCardTitle>
                                            </div>
                                            </CCardBody>
                                            <CCardFooter>
                                                <CButton color="success" onClick={(e) => unfollowHandler(item.following._id)}>Unfollow</CButton>
                                            </CCardFooter>
                                        </CCard>
                                    </CCol>)
                                    }
                                )}
                            </CRow>
                    </div>
                </li>
            </ul>
        </>
    )
}